/*
 * carousel initiates the carousel element with the Flickity plugin.
 *
 * Requires element with class 'js-carousel'.
 * The function is also called in every virtualpage change.
 *
 * Dependencies
 * - Flickity https://flickity.metafizzy.co/
 */

const carousel = () => {
  window.resizeVisibleCarousels = () => {};

  window.initVisibleCarousels = () => {
    if ($('.js-carousel').length === 0) {
      return;
    }

    window.$carousel = $('.js-carousel').flickity({
      adaptiveHeight: false,
      autoPlay: true,
      cellSelector: undefined,
      contain: true,
      draggable: true,
      dragThreshold: 3,
      freeScroll: false,
      friction: 0.3,
      groupCells: false,
      initialIndex: 0,
      lazyLoad: true,
      percentPosition: true,
      prevNextButtons: true,
      pageDots: true,
      resize: true,
      rightToLeft: false,
      setGallerySize: true,
      watchCSS: false,
      wrapAround: true,
      imagesLoaded: true,
    });
  };
  window.initVisibleCarousels();

  window.resizeVisibleCarousels = () => {
    if ($('.js-carousel').length === 0) {
      return;
    }
    window.$carousel.flickity('resize');
  };
};

export default carousel;
